import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

/* "Add Tornea to your phone" button. Self-hides when already installed
   (standalone display mode). Android/Chrome: consumes the captured
   beforeinstallprompt (index.js stores it on window.__a2hsPrompt). iOS has no
   API, so the button opens a short share-sheet instruction. */

const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches
  || window.navigator.standalone === true;

const InstallApp = ({ className = 'home-pill' }) => {
  const { t } = useTranslation();
  const [promptReady, setPromptReady] = useState(Boolean(window.__a2hsPrompt));
  const [showIosHint, setShowIosHint] = useState(false);

  useEffect(() => {
    const onAvailable = () => setPromptReady(true);
    window.addEventListener('a2hs-available', onAvailable);
    return () => window.removeEventListener('a2hs-available', onAvailable);
  }, []);

  // Only hide when the app already runs installed. Chrome's install prompt
  // often isn't ready on the first visit (SW just registered), so the button
  // must not depend on it: no prompt = show the how-to instead.
  if (isStandalone()) return null;

  const install = async () => {
    if (window.__a2hsPrompt) {
      const p = window.__a2hsPrompt;
      window.__a2hsPrompt = null;
      setPromptReady(false);
      p.prompt();
      try { await p.userChoice; } catch { /* dismissed */ }
    } else {
      setShowIosHint((v) => !v);
    }
  };

  return (
    <>
      <button type="button" className={className} onClick={install}
              title={promptReady ? t('installApp') : t('installHint')}>
        <Icon name="mobile-notch" />
        <span>{t('installApp')}</span>
      </button>
      {showIosHint && (
        <p className="install-app-hint">
          {isIos ? t('iosInstallHint') : t('installHint')}
        </p>
      )}
    </>
  );
};

export default InstallApp;
